import api from './api';

/**
 * Authentication Service Wrapper
 */
export const authService = {
  /**
   * Submits credentials to exchange for secure session tokens
   */
  login: async (email: string, password: string): Promise<any> => {
    const response = await api.post('/login', { email, password });
    
    if (response.data.success && response.data.data.token) {
      const user = response.data.data.user;
      if (user.role === 'superadmin') {
        localStorage.setItem('superadminToken', response.data.data.token);
        localStorage.setItem('superadminUser', JSON.stringify(user));
        if (response.data.data.session_id) localStorage.setItem('school_saas_session_id', response.data.data.session_id);
        localStorage.removeItem('school_saas_token');
        localStorage.removeItem('school_saas_user');
      } else {
        localStorage.setItem('school_saas_token', response.data.data.token);
        localStorage.setItem('school_saas_user', JSON.stringify(user));
        if (response.data.data.session_id) localStorage.setItem('school_saas_session_id', response.data.data.session_id);
        localStorage.removeItem('superadminToken');
        localStorage.removeItem('superadminUser');
      }
    }
    
    return response.data;
  },

  /**
   * Registers a new teacher account
   */
  register: async (data: { first_name: string; last_name: string; email: string; password: string; role?: string; employee_id?: string }): Promise<any> => {
    const response = await api.post('/register', data);
    return response.data;
  },

  /**
   * Discards tokens and wipes local session states
   */
  logout: (): void => {
    localStorage.removeItem('school_saas_token');
    localStorage.removeItem('school_saas_user');
    localStorage.removeItem('school_saas_session_id');
    localStorage.removeItem('superadminToken');
    localStorage.removeItem('superadminUser');
  },

  /**
   * Retrieves active teacher identity details
   */
  getCurrentUser: (): any | null => {
    const cached = localStorage.getItem('school_saas_user') || localStorage.getItem('superadminUser');
    if (!cached) return null;
    try {
      const user = JSON.parse(cached);
      return user;
    } catch (e) {
      return null;
    }
  },

  /**
   * Updates the locally cached user object after profile changes
   */
  updateCurrentUser: (updatedUser: any): any | null => {
    const existing = authService.getCurrentUser();
    if (!existing) {
      return null;
    }

    const merged = { ...existing, ...updatedUser };
    if (merged.role === 'superadmin') {
      localStorage.setItem('superadminUser', JSON.stringify(merged));
    } else {
      localStorage.setItem('school_saas_user', JSON.stringify(merged));
    }

    return merged;
  },

  /**
   * Fast state check for valid active sessions
   */
  isAuthenticated: (): boolean => {
    return localStorage.getItem('school_saas_token') !== null || localStorage.getItem('superadminToken') !== null;
  }
};
export default authService;
